<!-- @catalog Bordered data table built from divs, never <table>. Give it the CSS grid column template and fill it with CGridTableRow; rows join the table's grid through subgrid, so a header row, data rows and a full-width "toevoegen" row share one set of columns and the table scrolls sideways as a whole when they do not fit. Hide a header visually with a sr-only child, not on the cell itself. -->
<template>
  <div
    class="c-grid-table"
    role="table"
    :style="{ gridTemplateColumns: columns }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  /** The grid-template-columns every row in this table lays out with. */
  columns: string;
}>();
</script>

<style lang="scss" scoped>
.c-grid-table {
  @apply tw-grid tw-divide-y tw-divide-gray-100 tw-overflow-x-auto tw-rounded-xl tw-border tw-border-gray-200;
}
</style>
